import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "filters__header" }
const _hoisted_2 = ["aria-expanded", "aria-label"]
const _hoisted_3 = { class: "filter-toggle__label" }

import { computed, onMounted, onUnmounted } from 'vue';
import AdvancedFilter from '@/components/filter/AdvancedFilter.vue';
import ClearButton from '@/components/clear/ClearButton.vue';
import Search from '@/components/search/Search.vue';
import SimpleFilter from '@/components/filter/SimpleFilter.vue';
import { useFilterStore } from "../../stores/filterStore";
import { useStore } from '../../stores/store';
import { useQuery } from '@/services/query-service';

const FILTER_PANEL_MOBILE_BREAKPOINT = 992;


export default /*@__PURE__*/_defineComponent({
  __name: 'Filter',
  setup(__props) {

const store = useStore();
const filterStore = useFilterStore();
const { clearQueryParameters } = useQuery();
let filterPanelMediaQuery: MediaQueryList | null = null;
const handleFilterPanelBreakpointChange = (event: MediaQueryListEvent) => {
  syncFilterPanelWithViewport(event.matches);
};

const hasData = computed(() => store.originalSearchResult?.results.length > 0);
const filterToggleLabel = computed(() => filterStore.filterPanelOpen ? `Visa ${store.numTotalResult} resultat` : 'Filter');
const filterToggleAriaLabel = computed(() => filterStore.filterPanelOpen ? filterToggleLabel.value : 'Visa filter');

const syncFilterPanelWithViewport = (matchesMobileViewport: boolean) => {
  filterStore.filterPanelOpen = !matchesMobileViewport;
};

const toggleFilterPanel = () => {
  filterStore.filterPanelOpen = !filterStore.filterPanelOpen;
}

const clearFilters = () => {
  filterStore.activeFilters.splice(0, filterStore.activeFilters.length);
  filterStore.activeSearchFilters.splice(0, filterStore.activeSearchFilters.length);
  store.sorting.descending = true;
  store.sorting.dataKey = null;
  store.searchResult = store.originalSearchResult;
  clearQueryParameters();
}

onMounted(() => {
  filterPanelMediaQuery = window.matchMedia(`(max-width: ${FILTER_PANEL_MOBILE_BREAKPOINT}px)`);
  syncFilterPanelWithViewport(filterPanelMediaQuery.matches);
  filterPanelMediaQuery.addEventListener('change', handleFilterPanelBreakpointChange);
});

onUnmounted(() => {
  filterPanelMediaQuery?.removeEventListener('change', handleFilterPanelBreakpointChange);
});

return (_ctx: any,_cache: any) => {
  return (hasData.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["filter-container scrollbar", { 'filter-container--open': _unref(filterStore).filterPanelOpen, 'filter-container--collapsed': !_unref(filterStore).filterPanelOpen }]),
        ref: "scrollComponent",
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["filters", { 'filters--scrollable': _unref(filterStore).showAdvancedFilter }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "filter-component-heading" }, "Filtrering", -1 /* HOISTED */)),
            (_unref(filterStore).filterPanelOpen)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "filters__close-button button button--pop button--filter",
                  "aria-label": "Stäng filter",
                  onClick: toggleFilterPanel
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "icon icon--close" }, null, -1 /* HOISTED */)
                ])))
              : _createCommentVNode("v-if", true)
          ]),
          (_unref(filterStore).activeFilters.length > 0 || _unref(filterStore).activeSearchFilters.length > 0)
            ? (_openBlock(), _createBlock(ClearButton, {
                key: 0,
                class: "filters__clear",
                onClick: clearFilters
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(Search),
          _createVNode(SimpleFilter),
          _createVNode(AdvancedFilter)
        ], 2 /* CLASS */),
        _createElementVNode("button", {
          class: _normalizeClass(["filter-toggle button button--pop button--filter", { 'filter-toggle--panel-open': _unref(filterStore).filterPanelOpen }]),
          "aria-expanded": _unref(filterStore).filterPanelOpen,
          "aria-label": filterToggleAriaLabel.value,
          onClick: toggleFilterPanel
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "filter-toggle__leading-icon icon icon--horizontal-slider" }, null, -1 /* HOISTED */)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(filterToggleLabel.value), 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass(["filter-toggle__trailing-icon icon", _unref(filterStore).filterPanelOpen ? `icon--arrow-left` : `icon--arrow-right`])
          }, null, 2 /* CLASS */)
        ], 10 /* CLASS, PROPS */, _hoisted_2)
      ], 34 /* CLASS, NEED_HYDRATION */))
    : _createCommentVNode("v-if", true)
}
}

})